import React, { FC, useEffect, useState } from 'react';
import SectionContainer from '@common/components/SectionContainer';
import { TabMenu } from './TabMenu';
import { TabMenuFixed, TabContainer } from './Tabs.styles';

type TabsProps = {
  children: JSX.Element | JSX.Element[];
  selectedIndex: number;
};

export const Tabs: FC<TabsProps> = ({ children, selectedIndex = 0 }) => {
  const [menuTransparent, setMenuTransparent] = useState(true);
  useEffect(() => {
    const onScroll = () =>
      window.scrollY > 315 ? setMenuTransparent(false) : setMenuTransparent(true);

    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [selectedIndex]);
  return (
    <div>
      <SectionContainer>
        <TabMenu selectedIndex={selectedIndex}>{children as any}</TabMenu>
      </SectionContainer>
      <TabMenuFixed isTransparent={menuTransparent}>
        <SectionContainer>
          <TabMenu selectedIndex={selectedIndex}>{children as any}</TabMenu>
        </SectionContainer>
      </TabMenuFixed>
      <TabContainer>{children[selectedIndex]?.props?.children}</TabContainer>
    </div>
  );
};

export const Tab = (children) => <>{children}</>;
